import { render, staticRenderFns } from "./_ProductBlock.vue?vue&type=template&id=83b4707e"
import script from "./_ProductBlock.vue?vue&type=script&lang=js"
export * from "./_ProductBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports